import React from 'react';
import loader from '@assets/images/loader.gif';

// import CircularProgress from 'material-ui/CircularProgress';

class Spinner extends React.Component {
  render() {
    const {
      style,
      children
    } = this.props;

    return <div className={'SpinnerLoader'} style={{...style}}>
      <div className={'wrapper'}>
        <img src={loader} alt=""/>
        <div className={'text'}>{children}</div>
      </div>
    </div>
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.jsx